import React, { Component } from 'react';
import { Button, Row } from 'reactstrap';
import Api from '../../Api';
import Help from '../../HtmlHelpers';
import PageTitle from '../../Layout/PageTitle';
import UserGroups from '../../UserGroups';
import WmAuth from '../../WmAuth';

// const this.state.section = {
//   // example values
//   // type: 'location_items',
//   // form: LocationItem,
//   // title: 'View Location Item',
//   // listRoute: '../../location_items',
//   // listLabel: 'Location Item List',
//   // edit_admins: ['otto_orders_admin', 'otto_salesperson'],
// }

export default class ViewContainer extends Component {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    this.isAdmin = () => WmAuth.isEditAdmin(this.state, this.state.section.edit_admins);
    this.isSuperAdmin = () => WmAuth.isSuperAdmin(this.state);
    this.getItem = () => this.state.data && this.state.data[0] ? this.state.data[0] : {};
    this.getUuid = () => this.getItem().uuid;
    this.getFromResponse = response => {};
    this.setModalStatus = (tag, status) => this.setState({
      [tag]: status
    });
    this.fetchItem = () => {
      const type = this.state.section.type;
      Api.crudView(this.props.auth, type, this.state.uuid).then(response => {
        const data = [];
        let errors = [];
        const logs = [];
        const linkInfo = response.link_info || {};
        const includes = {};
        const additionalInfo = {};
        if (response.errors !== undefined) {
          errors = Help.convertRailsErrors(response.errors);
        }
        if (response.data !== undefined) {
          data.push(response.data.attributes);
        }
        if (response.included !== undefined) {
          response.included.forEach(d => {
            if (d.type === 'audit-logs') {
              logs.push(d.attributes);
            } else {
              const uuid = d.attributes.uuid;
              if (includes[d.type]) {
                includes[d.type][uuid] = d.attributes;
              } else {
                includes[d.type] = {
                  [uuid]: d.attributes
                };
              }
            }
          });
        }
        const handled = ['data', 'errors', 'included', 'link_info'];
        const additonalKeys = Object.keys(response).filter(k => !handled.includes(k));
        additonalKeys.forEach(key => additionalInfo[key] = response[key]);
        this.getFromResponse(response);
        this.setState({
          data,
          errors,
          includes,
          linkInfo,
          additionalInfo,
          auditLogs: logs,
          showModal: false
        });
      });
    };
    this.handleResponse = (response, message) => {
      if (response.data !== undefined) {
        this.props.alert.show(message, {
          type: 'success'
        });
        this.setState({
          data: null
        });
        this.updateData();
      } else if (response.errors !== undefined) {
        const errors = Help.convertRailsErrors(response.errors);
        this.props.alert.show(errors.join(', '), {
          type: 'error'
        });
      } else {
        this.props.alert.show('System error, please try again. If you continue to get this error, open a Help Desk ticket', {
          type: 'error'
        });
      }
    };
    this.updateFormKey = () => this.setState(prevState => ({
      formKey: prevState.formKey + 1
    }));
    this.formContents = () => {
      let contents = '';
      if (this.state.data && !this.state.showModal) {
        const FormName = this.state.section.form;
        contents = /*#__PURE__*/React.createElement(FormName, {
          key: "formKey_".concat(this.state.formKey),
          linkInfo: this.state.linkInfo || {},
          data: this.state.data,
          auditLogs: this.state.auditLogs,
          includes: this.state.includes,
          thisState: this.state,
          type: "view",
          editItem: 0,
          updateData: this.updateData,
          englishLanguageUuid: this.state.englishLanguageUuid,
          additionalFormProps: this.additionalFormProps()
        });
      }
      return contents;
    };
    this.editForm = () => this.state.section.form;
    this.editModal = () => {
      let contents = '';
      if (this.state.showModal) {
        const FormName = this.editForm();
        contents = /*#__PURE__*/React.createElement(FormName, {
          data: this.state.data,
          includes: this.state.includes,
          type: "edit",
          editItem: 0,
          showModal: this.state.showModal,
          closeModal: this.handleCloseModal,
          updateData: this.updateData,
          englishLanguageUuid: this.state.englishLanguageUuid,
          additionalFormProps: this.additionalFormProps()
        });
      }
      return contents;
    };
    this.handleCloseModal = function () {
      let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      _this.setState({
        ["showModal".concat(type)]: false
      });
    };
    this.handleOpenModal = function () {
      let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _this.setState({
        ["showModal".concat(type)]: true,
        ["selectedOptions".concat(type)]: opts
      });
    };
    this.openModal = () => this.handleOpenModal();
    this.updateData = () => this.fetchItem();
    this.editEvent = () => this.openModal();
    this.additionalButtons = () => {};
    this.additionalButtonsAfterList = () => {};
    this.additionalFormProps = () => ({});
    this.editButtonLabel = () => 'Edit';
    this.editButton = () => {
      let contents = '';
      if (this.isAdmin()) {
        contents = /*#__PURE__*/React.createElement(Button, {
          className: "otto__margin_right",
          color: "info",
          outline: true,
          onClick: this.editEvent
        }, this.editButtonLabel());
      }
      return contents;
    };
    const _uuid = this.props.match.params.uuid;
    this.state = {
      showModal: false,
      uuid: _uuid,
      formKey: 1
    };
  }
  async componentDidMount() {
    const userInfo = await UserGroups.UserInfo(this.props.auth);
    if (this.props.setUserInfo !== undefined) {
      this.props.setUserInfo(userInfo);
    }
    ;
    await this.setState({
      userGroups: userInfo.groups,
      englishLanguageUuid: userInfo.englishLanguageUuid
    });
    await this.fetchItem();
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "col-md-12"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
      className: "col-md-4 text-left"
    }, /*#__PURE__*/React.createElement(PageTitle, {
      title: this.state.section.title
    })), /*#__PURE__*/React.createElement("div", {
      className: "col-md-8 align-self-center text-right"
    }, this.additionalButtons(), this.editButton(), /*#__PURE__*/React.createElement(Button, {
      className: "otto__margin_right",
      outline: true,
      href: this.state.section.listRoute
    }, this.state.section.listLabel), this.additionalButtonsAfterList())), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
      className: "col-md-12"
    }, this.formContents())), this.editModal());
  }
}